import queryString from 'query-string';

export function getPage() {
    const parsedQuery = queryString.parse(window.location.search);
    return Number(parsedQuery.page || 1);
}

export function getQuery() {
  const parsedQuery = queryString.parse(window.location.search);
  return (parsedQuery.query || '');
}

export function getTags() {
  const parsedQuery = queryString.parse(window.location.search);
  return (parsedQuery.tags || '');
}

export function getSort() {
  const parsedQuery = queryString.parse(window.location.search);
  return parsedQuery.sort;
}

export function getCategory() {
  const parsedQuery = queryString.parse(window.location.search);
  return parsedQuery.category;
}